export enum AuthApplicationIds {
  Clinic = 1,
  Hospital = 2,
  Admin = 3,
}
